// src/components/AdminRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { hasPermission } from "../lib/permissions";

// Pass require="leads" (etc.) to gate a specific admin section — omit it
// for pages any staff member should reach regardless of their role (like
// the admin overview shell itself). Pass superAdminOnly for pages, like
// Team management, that stay super-admin-gated no matter what a role's
// permissions say. Super admins always pass require checks regardless.
export default function AdminRoute({ children, require, superAdminOnly }) {
  const { currentUser, businessProfile } = useAuth();
  if (!currentUser) return <Navigate to="/login" replace />;
  if (!businessProfile) return null; // still loading
  if (businessProfile.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (superAdminOnly && !businessProfile.superAdmin) return <Navigate to="/admin" replace />;
  if (require) {
    const ok = Array.isArray(require)
      ? require.some(p => hasPermission(businessProfile, p))
      : hasPermission(businessProfile, require);
    if (!ok) return <Navigate to="/admin" replace />;
  }
  return children;
}